export const Divider = () => <hr className="mx-1 border-t border-gray-100" />
